/**
 * Stok Yönetimi Utility Fonksiyonları
 * 
 * Aktif inşaat kullanımı ile genel stok havuzunu ayıran
 * merkezi hesaplama ve kontrol fonksiyonları.
 */

/**
 * Serbest stok hesapla (ayrılmamış, kullanılabilir miktar)
 */
export const hesaplaSerbest = (toplam, ayrilmis) => {
    const t = parseFloat(toplam) || 0;
    const a = parseFloat(ayrilmis) || 0;
    return Math.max(0, +(t - a).toFixed(2));
};

/**
 * Stok yeterliliği kontrolü
 */
export const stokYeterliMi = (mevcutStok, istenenMiktar) => {
    const s = parseFloat(mevcutStok) || 0;
    const m = parseFloat(istenenMiktar) || 0;
    return s >= m && m > 0;
};

/**
 * Stoktan düşme — negatif stok kontrolü ile
 * @returns {{ basarili: boolean, yeniStok: number, hata?: string }}
 */
export const stokDus = (mevcutStok, miktar) => {
    const s = parseFloat(mevcutStok) || 0;
    const m = parseFloat(miktar) || 0;

    if (m <= 0) return { basarili: false, yeniStok: s, hata: 'Miktar sıfırdan büyük olmalıdır' };
    if (s < m) return { basarili: false, yeniStok: s, hata: `Yetersiz stok. Mevcut: ${s}, İstenen: ${m}` };

    return { basarili: true, yeniStok: +(s - m).toFixed(2) };
};

/**
 * Stoğa ekleme
 * @returns {{ basarili: boolean, yeniStok: number }}
 */
export const stokEkle = (mevcutStok, miktar) => {
    const s = parseFloat(mevcutStok) || 0;
    const m = parseFloat(miktar) || 0;
    if (m <= 0) return { basarili: false, yeniStok: s, hata: 'Miktar sıfırdan büyük olmalıdır' };
    return { basarili: true, yeniStok: +(s + m).toFixed(2) };
};

/**
 * Tedarik kaynağı tipleri
 */
export const TEDARIK_KAYNAKLARI = [
    { key: 'tedarikci', label: 'Tedarikçi (Satın Alma)' },
    { key: 'stoktan', label: 'Stoktan Aktar' },
];
